import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Switch, Redirect, useLocation } from 'react-router-dom'

import BillingPage from 'pages/BillingPage/BillingPage'
import CheckoutPage from 'pages/CheckoutPage/CheckoutPage'
import LeadsPage from 'pages/LeadsPage/LeadsPage'
import OfferSetupPage from 'pages/OfferSetupPage/OfferSetupPage'
import SaleConfiguratorPage from 'pages/SaleConfiguratorPage/SaleConfiguratorPage'
import SummaryPage from 'pages/SummaryPage/SummaryPage'

import PATHS from './paths'
import { setLocation } from './store/router.reducer'

import { AuthenticatedRoute } from '~/auth/components/AuthenticatedRoute'
import { useAppDepsContext } from '~/core/hooks/useAppDepsContext'

export default function Routes() {
  const location = useLocation()
  const dispatch = useDispatch()
  const { analyticsService } = useAppDepsContext()

  useEffect(() => {
    analyticsService.pageView({
      title: document.title,
      location: window.location.host,
      path: location.pathname,
    })
    dispatch(setLocation(location))
  }, [location])

  return (
    <Switch>
      <Redirect
        exact
        path={PATHS.SALES}
        to={{ pathname: `${PATHS.SALES_START}`, search: location.search }}
      />
      <AuthenticatedRoute exact path={`${PATHS.SALES_START}`}>
        <SaleConfiguratorPage />
      </AuthenticatedRoute>
      <AuthenticatedRoute exact path={`${PATHS.OFFER_SETUP}`}>
        <OfferSetupPage />
      </AuthenticatedRoute>
      <AuthenticatedRoute exact path={`${PATHS.SUMMARY}`}>
        <SummaryPage />
      </AuthenticatedRoute>
      <AuthenticatedRoute exact path={`${PATHS.CHECKOUT}`}>
        <CheckoutPage />
      </AuthenticatedRoute>
      <AuthenticatedRoute exact path={`${PATHS.BILLING}`}>
        <BillingPage />
      </AuthenticatedRoute>
      <AuthenticatedRoute exact path={`${PATHS.LEADS}`}>
        <LeadsPage />
      </AuthenticatedRoute>
    </Switch>
  )
}
